/**
 * 工具包
 */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from './../common/GlobalStore'
import ViewUI from 'view-design'

/**
 * 引入语言包
 */
// import zh from '../../static/lang/zh';
// import en from '../../static/lang/en';

const zh=store.getters.zhJsonData||i18n.getLocaleMessage('zh')
const en=store.getters.enJsonData||i18n.getLocaleMessage('en')
console.log(zh)
//使用
Vue.use(VueI18n);

//实列
const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || window.navigator.language,
    messages: {
        en,  
        zh
    }
});
Vue.use(ViewUI, { 
    i18n: (key, value) => i18n.t(key, value)
  })
// Vue.use(ElementUI, {
//     i18n: (key, value) => i18n.t(key, value) // 在注册ElementUI时设置i18n的处理方法
// });
//暴露
export default i18n;
// export default ElementUI;

/**
 * 使用例子 html中{{$t("name")}}name对应到config/en || ch中对象生命的变量   jz中localStorage.setItem('locale',type);this.$i18n.locale = type;告诉他更新type为传递参数即en || zh
 */


// WEBPACK FOOTER //
// ./src/i18n/index.js